module.exports = __webpack_public_path__ + "static/media/mcm_3200.75a67cc4.ico";